// src/reportWebVitals.js
const reportWebVitals = (metric) => {
    console.log(metric); // Log or send metrics to your analytics service
};

export default reportWebVitals;
